import React, { useState, useEffect, useRef, useContext } from "react";

import { Stack, TextField, FormControl, RadioGroup, FormControlLabel, Radio, Button, Container, InputAdornment, Modal, InputLabel, Select, MenuItem, FormHelperText, SelectChangeEvent } from "@mui/material";

import DollarIcon from '@mui/icons-material/AttachMoney';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import UploadIcon from '@mui/icons-material/CloudUpload';
import LoadingButton from "@mui/lab/LoadingButton";
import dayjs from 'dayjs';
import config from '../../../hoa-config';
import PDFsContainerComponent from "../../../components/pdf-container-component/hoa-pool-access-form-pdf-container";
import { GlobalContext } from "../../../context/hoa-global-context";
import CustomDateField from "../../../Container/custom-date-field";

const PropertyBasicDetails = ({ propertyData,setPropertyData,onChangeText,error,setError, view, files, setFiles }: any) => {
    const { selectedValues, updatePropertyData, property, updateSelectedValues } = useContext<any>(GlobalContext)
    const [selectedOrganization, setSelectedOrganization] = useState('');
    const uploadButton1 = useRef(null);
    const [modalOpen, toggleOpen] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState({});
    const [documentName, setDocumentName] = useState('');

    const deleteClick = (document: string, name: any) => {
        setDocumentName(document);
		setSelectedDocument(name);
		toggleOpen(!modalOpen);
	}

    const handleClose = () => {
		toggleOpen(false);
	};

    const handleOrganizationSelection = (event: SelectChangeEvent) => {
        if(event) {
            const orgId = event.target.value as any;
            const orgName = config.hoaOrganizations.find((org: any) => org.id === orgId)?.name;
            setSelectedOrganization(orgId);
            setPropertyData({
                ...propertyData,
                ["organizationId"]: orgId,
                ["organizationName"]: orgName
            });
    
            setError({
                ...error,
                ["organizationId"]: false,
                ["organizationName"]: false
            });
        }
	};

    const handleChange = (event:any,type:string) => {
        onChangeText(event,type);
    }

    useEffect(() => {
        if(propertyData.organizationId && propertyData.organizationName) {
            setSelectedOrganization(propertyData.organizationId);
        }
    }, [propertyData.organizationId, propertyData.organizationName]);

    return (
        <Stack display={'flex'} direction={'row'}>
            <DeleteAttachmentComp
                open={modalOpen}
                toggleOpen={toggleOpen}
                handleClose={handleClose}
                documentName={documentName}
                state={propertyData}
                setState={setPropertyData}
                files={files}
                setFiles={setFiles}
                selectedDocument={selectedDocument}
                setSelectedDocument={setSelectedDocument}
                property={property}
                updatePropertyData={updatePropertyData}
                updateSelectedValues={updateSelectedValues}
			/>
        <Stack padding={'24px'} direction={'column'} spacing={2} borderRight={'1px solid #e8e8e8'} flexWrap={'wrap'}>
            <span className="text-3E3E3E-18px">Property Information</span>
            <TextField
                style={{ padding: "10px 0px", width: "280px" }}
                label={'External ID'}
                InputLabelProps={{ style: { fontSize: "14px"} }}
                variant="standard"
                value={propertyData?.hoaPropertyDetails?.externalId || ''}
                name='externalId'
                error={error['externalId'] || false}
                onChange={(e)=>handleChange(e,'hoaPropertyDetails')}
            />
            

            <Stack maxWidth={'598px'} direction={'row'}  flexWrap={'wrap'}>

                <TextField
                    style={{ padding: "10px 0px", width: "280px", marginRight:'17px' }}
                    label={'Street'}
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    variant="standard"
                    value={propertyData?.info?.street || ''}
                    name='street'
                    onChange={(e)=>handleChange(e,'info')}
                    error={error['street'] || false}
                />
                <TextField
                    style={{ padding: "10px 0px", width: "280px" }}
                    label={'City'}
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    variant="standard"
                    disabled={true}
                    InputProps={{
                        readOnly: true,
                    }}
                    value={propertyData?.info?.city || ''}
                    name='city'
                />
            </Stack>
            <Stack maxWidth={'598px'} direction={'row'}  flexWrap={'wrap'}>
                <TextField
                    style={{ padding: "10px 0px", width: "280px", marginRight:'17px' }}
                    label={'Country'}
                    variant="standard"
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    value={propertyData?.info?.country || 'USA'}
                    name='country'
                    disabled={true}
                    InputProps={{
                        readOnly: true,
                    }}
                />

                <TextField
                    style={{ padding: "10px 0px", width: "280px" }}
                    label={'State'}
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    variant="standard"
                    disabled={true}
                    InputProps={{
                        readOnly: true,
                    }}
                    value={propertyData?.info?.state || ''}
                    name='state'
                />
            </Stack>
            <Stack maxWidth={'598px'} direction={'row'}  flexWrap={'wrap'}>
                <TextField
                    style={{ padding: "10px 0px", width: "280px", marginRight:'17px' }}
                    label={'Zip'}
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    variant="standard"
                    disabled={true}
                    InputProps={{
                        readOnly: true,
                    }}
                    value={propertyData?.info?.zip || ''}
                    name='zip'
                />
                <TextField
                    style={{ padding: "10px 0px", width: "280px" }}
                    label={'Suggested HOA Name'}
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    variant="standard"
                    disabled={true}
                    InputProps={{
                        readOnly: true,
                    }}
                    value={propertyData?.suggestedHoaName || ''}
                    name='suggestedHoaName'
                />
            </Stack>

            <Stack direction={'row'} spacing={2} flexWrap={'wrap'}>
                <FormControl>
                    <InputLabel id='organization-select-label'>Organization</InputLabel>
                    <Select
                        labelId='organization-select-label'
                        id='organization-select'
                        label='Organization'
                        value={selectedOrganization || ''}
                        onChange={handleOrganizationSelection}
                        error={error['orgId'] || false}
                        disabled={view === 'update' && selectedOrganization ? true : false}
                        variant="standard"
                        style={{ padding: "5px 0px", width: "280px" }}
                    >
                        {config.hoaOrganizations.map((org: any) => {
                            return (
                                <MenuItem key={org.id} value={org.id}>
                                    {org.name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                    <FormHelperText error={error['orgId'] || false}>{error['orgId'] ? 'Please select an organization' : ''}</FormHelperText>
                </FormControl>
                <TextField
                    style={{ padding: "10px 0px", width: "280px" }}
                    label={'Organization ID'}
                    variant="standard"
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    name='organizationId'
                    value={propertyData?.organizationId || ''}
                    error={error['organizationId'] || false}
                    disabled
                />
            </Stack>

            <Stack direction={'row'} spacing={2} flexWrap={'wrap'}>
                <CustomDateField 
                    label='Onboarding Date'
                    error={false}
                    variant="standard"
                    style={{width: '280px', padding: "10px 0px"}}
                    value={dayjs(propertyData?.hoaPropertyDetails?.onboardingDate || null)}
                    handleChange={(value: any)=>handleChange({date:{key:'onboardingDate', value:value}},'hoaPropertyDetails')}
                />
                <TextField
                    style={{ padding: "10px 0px", width: "280px" }}
                    label={'Current Owner'}
                    variant="standard"
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    name='currentOwner'
                    type={'text'}
                    value={propertyData?.hoaPropertyDetails?.currentOwner || ''}
                    onChange={(e)=>handleChange(e,'hoaPropertyDetails')}
                />
            </Stack>

            <Stack direction={'row'} spacing={2} flexWrap={'wrap'}>
                <CustomDateField 
                    label='Date bought by owner'
                    error={false}
                    variant="standard"
                    style={{width: '280px', padding: "10px 0px"}}
                    value={dayjs(propertyData?.hoaPropertyDetails?.dateBoughtByOwner || null)}
                    handleChange={(value: any)=>handleChange({date:{key:'dateBoughtByOwner', value:value}},'hoaPropertyDetails')}
                />
                <TextField
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    style={{ padding: "10px 0px", width: "280px" }}
                    label={'Securitized By'}
                    variant="standard"
                    name='securitized'
                    value={propertyData?.hoaPropertyDetails?.securitized || ''}
                    onChange={(e)=>handleChange(e,'hoaPropertyDetails')}
                />
            </Stack>
            <Stack maxWidth={'598px'} direction={'column'}  flexWrap={'wrap'}>
                <TextField
                    style={{ padding: "10px 0px", width: "280px", marginRight:'17px' }}
                    label={'Property Appraisal Value'}
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    variant="standard"
                    value={propertyData?.hoaPropertyDetails?.propertyAppraisalValue || ''}
                    name='propertyAppraisalValue'
                    onChange={(e)=>handleChange(e,'hoaPropertyDetails')}
                />
                <TextField
                    style={{ padding: "10px 0px", marginRight:'17px' }}
                    label={'Additional Information'}
                    InputLabelProps={{ style: { fontSize: "14px"} }}
                    variant="standard"
                    multiline
                    value={propertyData?.hoaPropertyDetails?.propertyAppraisalAdditionalInfo || ''}
                    name='propertyAppraisalAdditionalInfo'
                    onChange={(e)=>handleChange(e,'hoaPropertyDetails')}
                />
            </Stack>
            </Stack>

            <Stack maxWidth={'450px'} padding={'24px'} direction={'column'} spacing={2} flexWrap={'wrap'}>
            <span className="text-3E3E3E-18px">Under Management</span>
            <FormControl style={{ marginTop: "17px" }}>
                <RadioGroup name="underManagement" value={propertyData?.hoaPropertyDetails?.underManagement || ""} onChange={(e)=>handleChange(e, 'hoaPropertyDetails')} style={{ display: "flex", flexDirection: "column" }}>
                    <FormControlLabel
                        style={{ fontSize: "14px" }}
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                    />
                    {propertyData?.hoaPropertyDetails?.underManagement === 'yes' && (
                        <TextField
                            style={{ padding: "10px 0px", marginRight:'17px' }}
                            label={'Additional Information'}
                            InputLabelProps={{ style: { fontSize: "14px"} }}
                            variant="standard"
                            multiline
                            value={propertyData?.hoaPropertyDetails?.underManagementAdditionalInfo || ''}
                            name='underManagementAdditionalInfo'
                            onChange={(e)=>handleChange(e,'hoaPropertyDetails')}
                        />
                    )}
                    <FormControlLabel
                        style={{ fontSize: "14px" }}
                        value="no"
                        control={<Radio />}
                        label="No"
                    />
                    {propertyData?.hoaPropertyDetails?.underManagement === 'no' && (
                        <Stack>
                            <CustomDateField 
                                label='Effective Sold Date'
                                error={false}
                                variant="standard"
                                style={{width: '280px', padding: "10px 0px"}}
                                value={dayjs(propertyData?.hoaPropertyDetails?.effectiveSoldDate || null)}
                                handleChange={(value: any)=>handleChange({date:{key:'effectiveSoldDate', value:value}},'hoaPropertyDetails')}
                            />
                            <TextField
                                style={{ padding: "10px 0px", marginRight:'17px' }}
                                label={'Additional Information'}
                                InputLabelProps={{ style: { fontSize: "14px"} }}
                                variant="standard"
                                multiline
                                value={propertyData?.hoaPropertyDetails?.underManagementEffectiveSoldDateAdditionalInfo || ''}
                                name='underManagementEffectiveSoldDateAdditionalInfo'
                                onChange={(e)=>handleChange(e,'hoaPropertyDetails')}
                            />
                        </Stack>
                    )}
                </RadioGroup>
            </FormControl>
            <Stack direction={'row'} spacing={2} flexWrap={'wrap'}>
                <CustomDateField 
                    label='Acquisition Date (Optional)'
                    error={false}
                    variant="standard"
                    style={{width: '280px', padding: "10px 0px"}}
                    value={dayjs(propertyData?.hoaPropertyDetails?.acquisitionDate || null)}
                    handleChange={(value: any)=>handleChange({date:{key:'acquisitionDate', value:value}},'hoaPropertyDetails')}
                />
            </Stack>
            </Stack>
        </Stack>
    )
}

export default PropertyBasicDetails;

const DeleteAttachmentComp = ({
    open,
    toggleOpen,
    handleClose,
    documentName,
    state,
    setState,
    files,
    setFiles,
    selectedDocument,
    setSelectedDocument,
    property,
    updatePropertyData,
    updateSelectedValues,
}: any) => {
	const [error, setError] = useState({ link: false, files: false });
	const [isLoading, setLoading] = useState(false);
    const doc = {
        name: selectedDocument.fileName
    }
	const handleDelete = async () => {
        setLoading(true);
        if(files && files[documentName].length){
            const arr = files[documentName].filter((item: any) => {
                return item.name != selectedDocument.name
            })
            setFiles({...files, [documentName]: arr})
            setLoading(false);
            handleClose();
            return;
        }
		let arr = state[documentName].filter((item: any) => {
			return item.fileName != selectedDocument.fileName;
		});
        setState({...state, [documentName]: arr})
        setLoading(false);
        handleClose();
	};
	const onClose = () => {
		handleClose();
	};
  
	return (
		<Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted once you save information. It cannot be retrieved afterward</p>
						</div>
					</Stack>
					
					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						{!isLoading ? (
							<>
								<Button onClick={() => onClose()} variant="outlined">
									No
								</Button>
								<Button onClick={handleDelete} variant="contained">
									Yes
								</Button>
							</>
						) : (
							<LoadingButton
								loading
								loadingIndicator="Deleting..."
								variant="outlined"
							>
								Deleting Data
							</LoadingButton>
						)}
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}